const hasCapitalLetter = {
  errorMessage: 'ERROR_HAS_CAPITAL_LETTER',
  rule: (value: any) => /[A-Z]/g.test(value),
};

export default hasCapitalLetter;
